import axios from "axios";

export const apiCommon = axios.create({
  baseURL: `${import.meta.env.VITE_URL_API}/api`,
  timeout: 60000,
  timeoutErrorMessage: "Não foi possível comunicar com o servidor",
});
